import { FC, Suspense } from 'react';
import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import PoiPostSection from './post';
import { PoiTopicSection } from './related';
import PoiDescriptionSection from './description';
import { $PoiInfo } from 'shared/atoms';
import { Loading } from '~/components/loading';
import { NotFound } from '~/components/not-found';
import { POIBodySkeleton } from '~/skeleton/poi';

export const PoiBodyInner: FC = () => {
  const { poi_id: poiId = '' } = useParams<{ poi_id: string }>();
  // @ts-ignore
  const { isShow = true } = useAtomValue($PoiInfo(poiId));

  if (!isShow) {
    return <NotFound />;
  }

  return (
    <>
      <PoiPostSection />
      {/* <PoiCampaignSection /> */}
      <Suspense fallback={<Loading variant="ball" fitParent={true} style={{ position: 'absolute' }} />}>
        <PoiTopicSection />
      </Suspense>
    </>
  );
};

export const PoiBody: FC = () => {
  return (
    <>
      <PoiDescriptionSection />
      <Suspense fallback={<POIBodySkeleton />}>
        <PoiBodyInner />
      </Suspense>
    </>
  );
};
